/**
 * This file contains some global CSS classes, that can be imported anywhere in the project
 * See global-styles.js to use it in a given component
 */
const style = (theme): any => ({
    mobileOnly: {
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    desktopOnly: {
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    centerVertical: {
        display: 'flex',
        alignItems: 'center',
        flex: 1,
    },
    roundButton: {
        marginRight: 10,
        padding: '16px 20px',
        borderRadius: 23,
        fontWeight: 'bold',
    },
    btnSuccess: {
        backgroundColor: theme.palette.success.main,
        color: theme.palette.common.white,
        '&:hover': {
            backgroundColor: theme.palette.success.light,
        },
    },
    btnWarning: {
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.common.white,
        '&:hover': {
            backgroundColor: theme.palette.warning.light,
        },
    },
    btnDanger: {
        backgroundColor: theme.palette.danger.main,
        color: theme.palette.common.white,
        '&:hover': {
            backgroundColor: theme.palette.danger.light,
        },
    },
    btnEdit: {
        backgroundColor: theme.palette.edit.main,
        color: theme.palette.common.white,
        '&:hover': {
            backgroundColor: theme.palette.edit.light,
        },
    },
    btnAutoWidth: {
        minWidth: 'auto',
    },
    header: {
        backgroundColor: theme.palette.colors.white,
        boxShadow: '0 3px 7px 0 #e5e5e5',
    },
    contentSpacing: {
        padding: theme.spacing(3),
        // TODO: understand why it doesn't apply caused of the div present before
        // '& .MuiBox-root > .LCRootViewEditBlock:first-child': {
        //     marginTop: 0 + '!important',
        // },
        '& .MuiBox-root > div': {
            marginTop: 0 + '!important',
        },
    },
    topBarContentSpacing: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    fabBotRight: {
        margin: theme.spacing(0),
        top: 'auto',
        right: theme.spacing(2),
        bottom: theme.spacing(2),
        left: 'auto',
        position: 'fixed',
    },
    notStickyHeader: {
        [theme.breakpoints.down('xs')]: {
            marginTop: 40,
        },
    },
    stickyHeader: {
        position: 'sticky',
        top: 0, // theme.mixins.toolbar.minHeight,
        [theme.breakpoints.down('xs')]: {
            top: 40,
            marginBottom: 30,
        },
        zIndex: 1000,
    },
    document: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    formLabel: {
        fontSize: 12,
        color: theme.palette.primary.dark,
        fontWeight: 500,
    },
    block: {
        display: 'flex',
        flexDirection: 'column',
        background: theme.palette.colors.white,
        boxShadow: '0px 0px 42px 0px rgba(0, 0, 0, 0.06)',
        borderRadius: 14,
        padding: '30px 50px',
        marginTop: 20,
        marginBottom: 20,
    },
    blockShadow: {
        borderRadius: 14,
        boxShadow: '0px 0px 42px 0px rgba(0, 0, 0, 0.06)',
        background: theme.palette.colors.white,
        marginTop: 20,
        marginBottom: 20,
    },
    blockShadowNew: {
        borderRadius: '0px 0px 4px 4px',
        background: 'transparent',
        marginTop: 20,
        marginBottom: 20,
    },
    blockSpacing: {
        display: 'flex',
        flexDirection: 'column',
        padding: '30px 50px',
    },
    blockMargin: {
        marginTop: 20,
        marginBottom: 20,
        borderRadius: 14,
        boxShadow: '0px 0px 42px 0px rgba(0, 0, 0, 0.06)',
    },
    title: {
        fontWeight: 700,
        fontSize: 18,
        color: theme.palette.primary.dark,
    },
    details: {
        borderLeft: `4px solid ${theme.palette.colors.greySeparator}`,
        borderRadius: 1,
        padding: '8px 0px 8px 30px',
        fontSize: 14,
        fontWeight: 400,
        color: theme.palette.colors.table.text,
    },
    infoLabel: {
        color: theme.palette.secondary.light,
    },
    inlineFlex: {
        display: 'inline-flex',
    },
});

export default style;
